<div class="modal-header">
  <h5 class="modal-title">
    <i class="cs-icon cs-icon-upload"></i> &nbsp;<ng-container i18n>Import Inventories from CSV Files</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-csv-file-parser
    [columnDefs]="columnDefs"
    [guide]="guide"
    (parsed)="onCsvFilesParsed($event)"
  ></app-csv-file-parser>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="create()" [disabled]="!files?.length" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>upload</ng-container>
  </button>
</div>
